import {
  SET_MAP_POINTS,
  SET_MAP_POINTS_IS_FETCHED,
  SET_MAP_POINTS_SEARCH_QUERY,
} from './constants';

const initialState = {
  searchQuery: '',
  isPointsFetched: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_MAP_POINTS: {
      const points = action.payload || [];
      return {
        ...state,
        points,
      };
    }
    case SET_MAP_POINTS_IS_FETCHED: {
      return {
        ...state,
        isPointsFetched: action.payload,
      };
    }
    case SET_MAP_POINTS_SEARCH_QUERY: {
      return {
        ...state,
        searchQuery: action.payload,
      };
    }
    default:
      return state;
  }
}
